import { render } from "./FinishQuestionForm.vue?vue&type=template&id=19ac80f2&scoped=true&ts=true"
import script from "./FinishQuestionForm.vue?vue&type=script&lang=ts"
export * from "./FinishQuestionForm.vue?vue&type=script&lang=ts"

import "./FinishQuestionForm.vue?vue&type=style&index=0&id=19ac80f2&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ac80f2"]])

export default __exports__